var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3221_55303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.601 22.1419H22.3045C21.5426 22.5143 20.7062 22.7097 19.8581 22.7133C18.9795 22.7133 18.1581 22.499 17.4117 22.1419H17.1153C16.0242 22.1422 14.9779 22.5757 14.2063 23.3472C13.4348 24.1188 13.0013 25.1651 13.001 26.2562V27.2847C13.001 27.7394 13.1816 28.1754 13.5031 28.4969C13.8246 28.8184 14.2606 28.999 14.7153 28.999H25.001C25.4556 28.999 25.8917 28.8184 26.2132 28.4969C26.5346 28.1754 26.7153 27.7394 26.7153 27.2847V26.2562C26.715 25.1651 26.2814 24.1188 25.5099 23.3472C24.7384 22.5757 23.6921 22.1422 22.601 22.1419V22.1419ZM19.8581 20.999C20.6492 20.999 21.4226 20.7644 22.0804 20.3249C22.7382 19.8854 23.2509 19.2607 23.5536 18.5298C23.8564 17.7989 23.9356 16.9946 23.7813 16.2187C23.6269 15.4427 23.246 14.73 22.6865 14.1706C22.1271 13.6112 21.4144 13.2302 20.6385 13.0759C19.8626 12.9215 19.0583 13.0008 18.3274 13.3035C17.5965 13.6063 16.9718 14.1189 16.5322 14.7767C16.0927 15.4345 15.8581 16.2079 15.8581 16.999C15.8578 17.5244 15.9611 18.0447 16.162 18.5301C16.3629 19.0155 16.6576 19.4566 17.0291 19.8281C17.4006 20.1996 17.8416 20.4942 18.3271 20.6951C18.8125 20.896 19.3328 20.9993 19.8581 20.999Z",
    fill: "#162930"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3221_55303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(10 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipients);
export default __webpack_public_path__ + "static/media/Recipients.9841522d.svg";
export { ForwardRef as ReactComponent };